import { Guest, Purchase, PurchaseItem } from "types";

export const isAutoGeneratedName = (value?: string) => !!(value && new RegExp(/ #\d+\s*$/).test(value));

export const isPrimaryGuest = (guest: Guest, purchase?: Purchase, item?: PurchaseItem) => {
    if (guest.primary || item?.quantity === 1) {
        return true;
    }

    if (purchase && "organizer" in purchase && guest.traveler) {
        return purchase.organizer?.id === guest.traveler.id;
    }

    // For a lot of bookings with multiple guests, all guests primary will be false. We assume that the first guest is primary
    if (item && "quantity" in item && item.quantity > 1 && !guest.primary) {
        // If there is no other primary in the list, then the first guest is primary
        const hasOtherPrimary = item.guests?.some((g) => g.primary);
        const guestIndex = item.guests?.findIndex((g) => g.id === guest.id);
        return guestIndex === 0 && !hasOtherPrimary;
    }

    return guest.primary;
};
